
import { Button } from "@/components/ui/button";
import { Save, X } from "lucide-react";

interface ActivityFormActionsProps {
  onSave: () => void;
  onCancel: () => void;
  isValid: boolean;
  uploading: boolean;
}

export const ActivityFormActions = ({ 
  onSave, 
  onCancel, 
  isValid, 
  uploading 
}: ActivityFormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2">
      <Button variant="outline" onClick={onCancel}>
        <X className="h-4 w-4 mr-2" />
        Cancel
      </Button>
      <Button onClick={onSave} disabled={!isValid}>
        <Save className="h-4 w-4 mr-2" />
        {uploading ? "Uploading..." : "Save"}
      </Button>
    </div>
  );
};
